import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { ArticleParagraph2 } from '@cian/ui-kit';
import { IconFunctionalSuccess16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './styles.css';

const ONLINE_RENTAL_AGREEMENT_LINK = '/rental-online-agreement';

interface IOnlineRentalAgreementLabelProps {
  onShow: () => void;
  onClick: () => void;
}

export const OnlineRentalAgreementLabel: React.FC<IOnlineRentalAgreementLabelProps> = ({ onShow, onClick }) => {
  return (
    <ActionAfterViewObserver callback={onShow} callbackDelay={1500}>
      <div className={styles['wrapper']}>
        <ul>
          <li>
            <IconFunctionalSuccess16 color="icon-main-default" />
            <ArticleParagraph2>Проверка собственника</ArticleParagraph2>
          </li>

          <li>
            <IconFunctionalSuccess16 color="icon-main-default" />
            <ArticleParagraph2>Защита от рисков</ArticleParagraph2>
          </li>

          <li>
            <IconFunctionalSuccess16 color="icon-main-default" />
            <ArticleParagraph2>Все документы онлайн</ArticleParagraph2>
          </li>
        </ul>

        <ArticleParagraph2>
          <a href={ONLINE_RENTAL_AGREEMENT_LINK} onClick={onClick} target="_blank" rel="noreferrer">
            Подробнее о сервисе
          </a>
        </ArticleParagraph2>
      </div>
    </ActionAfterViewObserver>
  );
};
